import { Link } from 'wouter';
import { useSelector, useDispatch } from 'react-redux';
import { useEffect } from 'react';
import { actions } from '@/store/store.js';

const AccessFeatureList = () => {
  const dispatch = useDispatch();
  const accessFeatures = useSelector((state) => Object.values(state.accessFeatures.records));

  useEffect(() => {
    dispatch(actions.accessFeatures.loadAll());
  }, []);

  return (
    <div className="container">
      <div>
        <h1 className="mb-4">Access Page</h1>
        <p className="text-muted mb-4">
          Access your collection of premium digital products. Click on any feature to view or unlock it.
        </p>

        <div className="list-group">
          {accessFeatures.map((af) => (
            <Link key={af.id} to={`/product/${af.identity}`} className="card mb-3 access-feature-card">
              <div className="row align-items-center align-items-lg-start">
                <div className="col-md-3 col-lg-2 mb-md-0">
                  <img
                    src={af.image_227x303}
                    alt={af.title}
                    className="img-fluid rounded d-none d-md-inline-block"
                    style={{ aspectRatio: '0.75/1', objectFit: 'cover' }}
                  />
                  <img
                    src={af.image_1440x480}
                    alt={af.title}
                    className="img-fluid rounded d-md-none"
                    style={{ aspectRatio: '3/1', objectFit: 'cover' }}
                  />
                </div>
                <div className="col-md-8">
                  <div className="p-3 p-md-0">
                    <h5 className="mb-2 mt-0 mt-lg-4">{af.title}</h5>
                    <p className="mb-0 text-muted">{af.description}</p>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccessFeatureList;
